import type { App, Plugin } from 'vue'

import Row from './Row'
import Col from './Col'
import Item from './Item'

Row.install = function (app: App) {
  // @ts-ignore
  app.component(Row.name, Row)
  return app
}
Col.install = function (app: App) {
  // @ts-ignore
  app.component(Col.name, Col)
  return app
}
Item.install = function (app: App) {
  // @ts-ignore
  app.component(Item.name, Item)
  return app
}

export const Rowflex = Row as typeof Row & Plugin
export const Colflex = Col as typeof Col & Plugin
export const Flexitem = Item as typeof Item & Plugin

export type { RowProps as RowflexProps } from './Row'
export type { ColProps as ColflexProps } from './Col'
export type { ItemProps as FlexitemProps } from './Item'
